module.exports = __webpack_public_path__ + "img/mockup-academy-SA.8087049f.jpg";